import { useReport } from './hooks/use-context';

export function CollaboratorData() {
  const { body } = useReport();

  const {
    name,
    cadastro,
    cargo,
    area_atuacao,
    coordenador,
    gestor,
    record_responsible,
    record_responsible_text,
  } = body;

  // Get properties from collection_item (fallback for previous forms that still used the old format)
  const collectionItem = name?.answers?.[0]?.collection_item;
  const getProperty = (propName: string) =>
    collectionItem?.properties?.find((prop) => prop.name === propName)
      ?.content;

  const cadastroVal =
    cadastro?.answers?.[0]?.content || collectionItem?.code || '-';
  const cargoVal = cargo?.answers?.[0]?.content || getProperty('CARGO') || '-';
  const setorVal =
    area_atuacao?.answers?.[0]?.content || getProperty('AREA ATUAÇÃO') || '-';
  const coordenadorVal =
    coordenador?.answers?.[0]?.content || getProperty('COORDENADOR') || '-';
  const gestorVal =
    gestor?.answers?.[0]?.content || getProperty('GESTOR') || '-';
  const respRegistroVal =
    record_responsible?.answers?.[0]?.content ||
    record_responsible_text?.answers?.[0]?.content ||
    '-';

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#ffffcc',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        DADOS DO COLABORADOR
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '3fr 8fr',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        {/* Labels column */}
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'repeat(7, 1fr)',
          }}
        >
          <div style={cellStyle}>NOME</div>
          <div style={cellStyle}>CADASTRO</div>
          <div style={cellStyle}>CARGO</div>
          <div style={cellStyle}>SETOR</div>
          <div style={cellStyle}>COORDENADOR</div>
          <div style={cellStyle}>GESTOR</div>
          <div style={cellStyle}>RESPONSÁVEL PELO REGISTRO</div>
        </div>

        {/* Values column */}
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'repeat(7, 1fr)',
          }}
        >
          <div style={{ ...cellStyle, ...valueStyle }}>
            {name?.answers?.[0]?.content || '-'}
          </div>
          <div style={{ ...cellStyle, ...valueStyle }}>{cadastroVal}</div>
          <div style={{ ...cellStyle, ...valueStyle }}>{cargoVal}</div>
          <div style={{ ...cellStyle, ...valueStyle }}>{setorVal}</div>
          <div style={{ ...cellStyle, ...valueStyle }}>{coordenadorVal}</div>
          <div style={{ ...cellStyle, ...valueStyle }}>{gestorVal}</div>
          <div style={{ ...cellStyle, ...valueStyle }}>{respRegistroVal}</div>
        </div>
      </div>
    </div>
  );
}
